<template>
  <aside class="menu-l" id="menuizquierda">
    <h6>Menu</h6>
    <router-link id="menuizquierda_inicio" to="/Tablero/Bienvenida">
      <i class="fas fa-home"></i>
      <h5 class="text-left d-none d-sm-none d-md-none d-lg-block">Inicio</h5>
    </router-link>
    <router-link id="menuizquierda_paginaweb" to="/Inicio">
      <i class="fas fa-globe-americas"></i>
      <h5 class="text-left d-none d-sm-none d-md-none d-lg-block">Página Web</h5>
    </router-link>
    <!-- <router-link id="menuizquierda_noticias" to="/Tablero/Noticias">
      <i class="fas fa-newspaper"></i>
      <h5 class="text-left d-none d-sm-none d-md-none">Noticias</h5>
    </router-link> -->
    <router-link v-for="menu in menusPrincipales" v-bind:data="menu" v-bind:key="menu.TipoSistemaId" :to="menu.RutaDeAcceso">
      <i :class="menu.Icono"></i>
      <h5 class="text-left d-none d-sm-none d-md-none d-lg-block">{{menu.Nombre}}</h5>
    </router-link>
    <router-link id="menuizquierda_usuario" to="/Tablero/Usuarios">
      <i class="fas fa-id-card"></i>
      <h5 class="text-left d-none d-sm-none d-md-none d-lg-block">Usuario</h5>
    </router-link>
  </aside>
</template>

<script>
  export default {
    computed: {
      menusPrincipales(){
        return this.$store.state.Login_Usuario.MenuPrincipal;
      }
    }
  }
</script>

<style scoped>
.menu-l{
  background-color: rgb(0,117,115) !important;
}
@media(max-width: 991px) {
  .menu-l {
   
    width: 80px;
    text-align: center !important;
  }  
  
  .menu-l h6 {

    width: 100% !important;
    padding-left: 0;
    text-align: center !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Tablero/MenuIzquierda.vue